function insertContent(render, block){
    render.appendChild(block.cloneNode(true));
}

async function fetchContent(path, id, parent) {   
    try {
        let response = await fetch(path);
        let responseText = await response.text();
        
        let parser = new DOMParser();
        let doc = parser.parseFromString(responseText, 'text/html');
        let block = doc.querySelector(`${id}`);

        let render = document.querySelector(`${parent}`)

        // render.innerHTML += block.innerHTML;
        // console.log(response.status);

        if(response.status === 200){
            insertContent(render, block);
        }
    }
    catch (err) {
        // console.log('Fetch error:' + err);
        console.log(`Fetch Error: ${err}`);
    }
}

function renderLayout(){
    // Components
    // Header
    fetchContent('./components/header.html', '#header-template', 'header');

    // Main
    fetchContent('./content/modulo/index.html', '#step-0', '.step-0');
    fetchContent('./content/modulo/index.html', '#step-1', '.step-1');

    // HeadMain
    fetchContent('./components/menu-modulo.html', '#menu-modulo', '.head-content');
    fetchContent('./components/scroll-bar.html', '#scroll-bar', '.scroll-bar');

    // Nav Progress
    fetchContent('./components/menu-progreso.html', '#menu-progreso', '.nav-progress');

    // Footer
    fetchContent('./components/footer.html', '#footer-template', 'footer');
    
    // Toast Topics
    fetchContent('./components/toasts-topics.html', '#toasts-topics', '.live-toasts');

    
    // Modals Topics
    fetchContent('./components/modals/layout.html', '#modals-layout', '.live-modals');
    // Lección 1
    fetchContent('./components/modals/l1/01-activacion.html', '#modals-l1-activacion', '.live-modals');
    fetchContent('./components/modals/l1/02-profundizacion.html', '#modals-l1-profundizacion', '.live-modals');
    fetchContent('./components/modals/l1/03-dialogo.html', '#modals-l1-dialogo', '.live-modals');
}
renderLayout();